// extracted by css-extract-rspack-plugin
export default {"RowFrame":"BoardRowFrame-module__RowFrame__QcnVP","Header":"BoardRowFrame-module__Header__phTlJ","Cells":"BoardRowFrame-module__Cells__avez7"};